module.exports = __webpack_public_path__ + "static/media/sound2.5d80de54.mp3";